module.exports = __webpack_public_path__ + "img/type-usa.9e521e04.png";